export default "__VITE_ASSET__be3d8c1f__"